<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1">Four</h1>
<p class="noindent">After that night at the motel, the divorce seemed painless.</p>
<p class="p1">Julie had a new life now, with a new lover, and she seemed uninterested in holding on to much of her life with Mark.</p>
<p class="p1">They split their assets, pretty much down the middle.</p>
<p class="p1">Julie took what she wanted from the house and left the rest behind for Mark. He wasn't all that interested in keeping mementos of his married life either and got rid of everything — including his car — less than a week after the divorce was finalized.</p>
<p class="p1">The next day he walked into the Peterbilt dealership on Rutherford Road and ordered a four year-old Model 379.</p>
<p class="p1">A few days later, he took possession of the rig, christening it "Mother Load."</p>
<p class="p1">And a week after that he was hauling a trailer westward, putting as many miles as he could between himself and his old life.</p>
<p class="p1">His marriage was over.</p>
<p class="p1">And he was through being a private investigator.</p>
<p class="p1">But something told him, that the adventures he longed for would find him on the open road, no matter where went.</p>
<p class="p1">He wasn't disappointed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter14.vue?cc3e781e